module.exports = __webpack_public_path__ + "static/media/but-why.fc3c9f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/but-why.jpg
// module id = 1523
// module chunks = 0